import React from "react";
import styles from "./AddLoad.module.scss";
import { Button, Input, Modal } from "antd";
import addIcon from "../../Assets/plusIcon.svg";
import dotsIcon from "../../Assets/dotsIcon.svg";
import { useAppDispatch } from "Redux/store";
import { createOrder } from "Redux/Order/reducer";
import { Controller, useForm } from "react-hook-form";

interface AddLoadProps {
  visible: any;
  onCancel: any;
  setOpen: (open: boolean) => void;
}

// TODO: useForm: control, handleSubmit, formState.errors
// Contreller - reactHookForm

export const AddLoad: React.FC<AddLoadProps> = ({ onCancel, visible }) => {
  const dispatch = useAppDispatch();
  const { control, handleSubmit } = useForm();

  const handleAddLoad = (values: any) => {
    // console.log(values);
    dispatch(createOrder(values));
  };

  return (
    <Modal
      title={<h1>Add load</h1>}
      open={visible}
      footer={true}
      maskClosable={true}
      width={410}
      onCancel={onCancel}
      className={styles.addLoad}
    >
      <form onSubmit={handleSubmit(handleAddLoad)}>
        <label htmlFor="pick_up_at">Pick-up</label>
        <Controller
          name="pick_up_at"
          control={control}
          render={({ field }) => (
            <Input
              type="text"
              className={styles.addLoad__pickupInput}
              {...field}
              required
            />
          )}
        />

        <div className={styles.addLoad__pickupField}>
          <Controller
            control={control}
            name="pick_up_date_EST"
            render={({ field }) => (
              <Input className={styles.addLoad__pickupField__mainInput}
              type="date"
              {...field}
              />
            )}
          />

          <Input
            className={styles.addLoad__pickupField__secondInput}
            value="EST"
            readOnly
          />
          <img src={addIcon} alt="add-icon" />
          <img src={dotsIcon} alt="dots-icon" />
        </div>
        <label htmlFor="delivery">Delivery</label>
        <Controller
          name="deliver_to"
          control={control}
          render={({ field }) => (
            <Input
              type="text"
              className={styles.addLoad__deliveryInput}
              {...field}
              required
            />
          )}
        />
        <Controller
          name="this_posting_expires_est"
          control={control}
          defaultValue="2024-04-20T00:00:28.012Z"
          render={({ field }) => (
            <Input
              type="text"
              className={styles.addLoad__time}
              {...field}
              required
            />
          )}
        />

        <div className={styles.addLoad__deliveryField}>
          <Controller
          control={control}
          name="deliver_date_EST"
          render={({field}) => (
            <Input className={styles.addLoad__deliveryField__mainInput} type="date" {...field}/>
          )}
          />

          <Input
            className={styles.addLoad__deliveryField__secondInput}
            value="EST"
            readOnly
          />
          <img src={addIcon} alt="add-icon" />
          <img src={dotsIcon} alt="dots-icon" />
        </div>
        <label htmlFor="order_number">Order number</label>
        <Controller
          name="order_number"
          control={control}
          render={({ field }) => (
            <Input
              type="number"
              className={styles.addLoad__deliveryInput}
              {...field}
              required
            />
          )}
        />
        <label htmlFor="reply-email">Reply email</label>

        <Input
          className={styles.addLoad__replyInput}
          name="reply-email"
          type="email"
        />
        <label htmlFor="note">Note</label>
        <Controller
          control={control}
          name="notes"
          render={({ field }) => (
            <Input
              className={styles.addLoad__noteInput}
              type="text"
              {...field}
            />
          )}
        />

        <p>Dims</p>
        <div className={styles.addLoad__dims}>
          <Input
            className={styles.addLoad__dims__input}
            name="dims"
            type="text"
            placeholder="Length"
          />
          <Input
            className={styles.addLoad__dims__input}
            name="dims"
            type="text"
            placeholder="Width"
          />
          <Input
            className={styles.addLoad__dims__input}
            name="dims"
            type="text"
            placeholder="Height"
          />
          <Controller
            name="weight"
            control={control}
            render={({ field }) => (
              <Input
                className={styles.addLoad__dims__input}
                type="text"
                placeholder="Weight"
                {...field}
              />
            )}
          />

          <Controller
            control={control}
            name="pieces"
            render={({ field }) => (
              <Input
                className={styles.addLoad__dims__input}
                type="text"
                placeholder="Pieces"
                {...field}
              />
            )}
          />
        </div>
        <Button className={styles.addLoad__btn} htmlType="submit">
          Add load
        </Button>
      </form>
    </Modal>
  );
};
